import { Flex } from '@chakra-ui/core'
import { css } from '@emotion/core'
import { Images, Video } from 'lucide-react'
import React from 'react'

interface IProps {
  onImageUploadClick: () => void
  onVideoUploadClick?: () => void
  isLoading?: boolean
}

export const AddMediaButton: React.FC<IProps> = ({ onImageUploadClick, onVideoUploadClick, isLoading }) => {
  return (
    <Flex alignItems="center" style={{ columnGap: '10px' }}>
      {/* Image Upload Button */}
      <Flex
        onClick={!isLoading ? onImageUploadClick : undefined}
        borderRadius="full"
        bg="black"
        w="30px"
        h="30px"
        alignItems="center"
        justifyContent="center"
        cursor={isLoading ? 'not-allowed' : 'pointer'}
        boxShadow="0px 0px 2px 1px #E2E8F0"
        opacity={isLoading ? 0.5 : 1}
        transition="transform 0.3s ease"
        css={css`
          &:hover {
            transform: ${isLoading ? 'none' : 'scale(1.2)'};
          }
        `}
      >
        <Images color="white" size={15} />
      </Flex>

      {/* Video Upload Button (optional) */}
      {onVideoUploadClick && (
        <Flex
          onClick={!isLoading ? onVideoUploadClick : undefined}
          borderRadius="full"
          bg="black"
          w="30px"
          h="30px"
          alignItems="center"
          justifyContent="center"
          cursor={isLoading ? 'not-allowed' : 'pointer'}
          boxShadow="0px 0px 2px 1px #E2E8F0"
          opacity={isLoading ? 0.5 : 1}
          transition="transform 0.3s ease"
          css={css`
            &:hover {
              transform: ${isLoading ? 'none' : 'scale(1.2)'};
            }
          `}
        >
          <Video color="white" size={15} />
        </Flex>
      )}
    </Flex>
  )
}
